import { useFormikContext } from 'formik';
import { usePolicies } from './usePolicies';
import {
  buildFilClaimInsuranceOptions,
  getFilteredMetadata,
} from '../../utility/file-claim';
import { useFileClaimEventOptions } from './useFileClaimEventOptions';
import { MetadataFiltering } from '../../utility/node/sanity/claimQuestions.types';
import { usePolicyById } from './usePolicyById';

export const useMetadata = (
  metadata: string | null,
  metadataFiltering: MetadataFiltering[] | null,
) => {
  const { values } = useFormikContext<any>();

  const { policies, policiesLoading, policiesErrors } = usePolicies(
    values.event.incidentDate,
    { fetch: metadata === 'policyOptions' },
    true,
  );

  const { eventOptions, eventOptionsLoading, eventOptionsErrors } =
    useFileClaimEventOptions(
      values?.policy?.policyId, //|| '7882104', //TODO: remove the number!!! this is for testing only
      metadata === 'claimEventOptions',
      values.case.policyObjectId,
    );

  const { policy } = usePolicyById(
    values?.policy?.policyId, //|| '7882104', //TODO: remove the number!!! this is for testing only,
  );

  switch (metadata) {
    case 'contactDetails':
      return { name: 'contactDetails' };
    case 'policyOptions':
      const options = buildFilClaimInsuranceOptions(policies);

      return {
        policies,
        isLoading: policiesLoading,
        policiesErrors,
        options: getFilteredMetadata(options, metadataFiltering),
      };
    case 'claimEventOptions':
      return {
        options: getFilteredMetadata(eventOptions, metadataFiltering),
        isLoading: eventOptionsLoading,
        errors: eventOptionsErrors,
      };
    case 'policyObjectOptions':
      //this is for job title
      const jobFields = policy?.policyLines[0]?.policyObjects[0]?.fields?.find(
        (field) => field.name === 'stillingsbeteg',
      );
      const policyObjectOptions = jobFields?.metadata?.options;
      return {
        isLoading: policiesLoading,
        options: policyObjectOptions,
      };

    default:
      return null;
  }
};
